import {Utilities} from '@shared/utilities/utilities.model';
import {Component, Input, ViewEncapsulation} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatCheckboxChange} from '@angular/material';

@Component({
	selector: 'amd-select-check-all',
	template: `
		<mat-checkbox class="mat-option"
		              [disableRipple]="true"
		              [indeterminate]="isIndeterminate()"
		              [checked]="isChecked()"
		              (click)="$event.stopPropagation()"
		              (change)="toggleSelection($event)">
			{{text}}
		</mat-checkbox>
	`,
	styleUrls: ['./amd-select-check-all.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class SelectCheckAllComponent {

	@Input() model: FormControl;
	@Input() values: any[] = [];
	@Input() text: string = 'Seleziona Tutti';

	constructor() {
	}

	isChecked(): boolean {
		
		if (this.model && this.model.value && !Utilities.isVoid(this.values)) {
			return this.model.value && this.values.length
				&& (this.model.value.length === this.values.length);
		} else {
			return false;
		}
	}

	isIndeterminate(): boolean {
		
		if (this.model && this.model.value && !Utilities.isVoid(this.values)) {
			return this.model.value && this.values.length && this.model.value.length
				&& this.model.value.length < this.values.length;
		} else {
			return false;
		}
	}

	toggleSelection(change: MatCheckboxChange): void {

		if (!this.model || !change) {
			return;
		}

		if (change.checked) {
			this.model.setValue(this.values);
		} else {
			this.model.setValue([]);
		}
	}
}
